import { ReportFragment } from '../../../../models';

const isTotalsSummaryCollection = (value: ReportFragment) => value.type === 'collection' && value.subType === 'totals';

export default isTotalsSummaryCollection;
